import { CheckCircle } from "lucide-react";

const EtudiantCertificat = () => {
  // Données des parcours/diplômes
  const diplomes = [
    {
      id: 1,
      nom: "UNIVERSITY",
      logo: "/images/armoirie-transp.png",
    },
    {
      id: 2,
      nom: "Université",
      logo: "/images/armoirie-transp.png",
    },
    {
      id: 3,
      nom: "University",
      logo: "/images/armoirie-transp.png",
    },
  ];

  // Données des formations/certifications
  const formations = [
    {
      id: 1,
      titre: "Fondements et valeurs de la République",
      type: "Certificat d'Agent de la République",
      logo: "/images/valeur.png",
    },
    {
      id: 2,
      titre: "Éthique et déontologie du Fonctionnaire et Agent de l'État",
      type: "Certificat d'Agent Éthique",
      logo: "/images/Ethique-et-Deontologie.jpg",
    },
    {
      id: 3,
      titre: "Corruption et bonne gouvernance",
      type: "Certificat d'Agent de la bonne gouvernance",
      logo: "/images/Corruption.png",
    },
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-10">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Certification et Gamification
        </h1>
        <br />
        <h2 className="text-xl font-semibold text-gray-700 mb-4">
          Passez votre certification
        </h2>
        <p className="text-gray-600">
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
          nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat
          volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation
          ullamcorper suscipit
        </p>
      </div>

      {/* Parcours / Diplôme */}
      <div className="mb-12 max-w-4xl">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Parcours / Diplome
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {diplomes.map((diplome) => (
            <div
              key={diplome.id}
              className="flex flex-col items-center border border-gray-200 rounded-lg"
            >
              <div className="w-32 h-32 mb-4">
                <img
                  src={diplome.logo}
                  alt={diplome.nom}
                  className="w-full h-full object-contain"
                />
              </div>
              <button className="bg-green-600 text-white font-bold py-3 px-8 md:py-3 md:px-8 mobile:py-2 mobile:px-4 tablet:py-2 tablet:px-6 rounded-md w-full text-center text-xs md:text-sm">
                DETAILS
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Formation / Certification */}
      <div className="max-w-4xl">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Formation / Certification
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {formations.map((formation) => (
            <div
              key={formation.id}
              className="border border-gray-200 rounded-lg p-4"
            >
              <div className="mb-2">
                <CheckCircle
                  className="text-green-600 inline-block mr-2"
                  size={20}
                />
                <span className="font-medium text-green-600">FORMATION</span>
              </div>

              <div className="mb-4 min-h-[80px]">
                <h3 className="text-orange-500 font-bold mb-1">
                  {formation.titre}
                </h3>
                <p className="text-xs text-gray-600">({formation.type})</p>
              </div>

              <button className="bg-green-600 text-white text-xs font-bold py-2 px-4 rounded-md w-full text-center uppercase">
                Passer votre certificat
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EtudiantCertificat;
